module.exports = __webpack_public_path__ + "img/1224f.57628365.svg";